import { useEffect, useRef, useState } from "react";
import { Volume2, Loader2, Square } from "lucide-react";
import { toast } from "sonner";
import { api, mediaUrl, errorText } from "@/lib/api";

let current = null;

const stopCurrent = () => {
  if (!current) return;
  current.audio.pause();
  current.reset();
  current = null;
};

export const ListenButton = ({ termId, example, compact = false, testId = "listen-button" }) => {
  const [state, setState] = useState("idle");
  const mine = useRef(null);

  useEffect(() => () => { if (current && current === mine.current) stopCurrent(); }, []);

  const toggle = async () => {
    if (state === "playing") return stopCurrent();
    stopCurrent();
    setState("loading");
    try {
      const { data } = await api.post(`/terms/${termId}/audio`, null, { params: example != null ? { example } : {} });
      const audio = new Audio(mediaUrl(data.path));
      const entry = { audio, reset: () => setState("idle") };
      audio.onended = () => { if (current === entry) current = null; setState("idle"); };
      stopCurrent();
      current = mine.current = entry;
      await audio.play();
      setState("playing");
    } catch (e) {
      if (e?.name !== "AbortError") toast.error(errorText(e));
      setState("idle");
    }
  };

  const Icon = state === "loading" ? Loader2 : state === "playing" ? Square : Volume2;
  const label = state === "playing" ? "Ferma" : state === "loading" ? "Preparo la voce…" : "Ascolta";
  if (compact)
    return (
      <button onClick={toggle} disabled={state === "loading"} aria-label={label} title={label} data-testid={testId} className={`ink-press flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-[var(--ink)] disabled:opacity-70 ${state === "playing" ? "bg-[var(--ink)] text-white" : "bg-[var(--sun)]"}`}>
        <Icon className={`h-4 w-4 ${state === "loading" ? "animate-spin" : ""}`} />
      </button>
    );
  return (
    <button onClick={toggle} disabled={state === "loading"} data-testid={testId} className="ink-box-sm ink-press flex items-center gap-2 rounded-full bg-[var(--sun)] px-4 py-2 text-sm font-extrabold disabled:opacity-70">
      <Icon className={`h-4 w-4 ${state === "loading" ? "animate-spin" : ""}`} /> {label}
    </button>
  );
};
